import { render, staticRenderFns } from "./GroupModalForm.vue?vue&type=template&id=49c13e5c&scoped=true&lang=pug"
import script from "./GroupModalForm.vue?vue&type=script&lang=js"
export * from "./GroupModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c13e5c",
  null
  
)

export default component.exports